import { fn } from '@ember/helper';
import { action } from '@ember/object';
import momentAdd from 'ember-moment/helpers/moment-add';
import momentFormat from 'ember-moment/helpers/moment-format';
import utc from 'ember-moment/helpers/utc';
import Nav from 'ember-power-calendar/components/power-calendar/nav';
import moment from 'moment-timezone';
import BvBtn from 'volta/components/bv-btn';
import BvSelect from 'volta/components/bv-select';
import BvText from 'volta/components/bv-text';
import stopPropagation from 'volta/helpers/stop-propagation';

import type { PowerCalendarAPI } from 'ember-power-calendar/components/power-calendar';
import type { Select } from 'ember-power-select/components/power-select';

export default class BvCalendarNavComponent extends Nav {
  <template>
    <nav class='ember-power-calendar-nav'>
      <BvBtn
        class='ember-power-calendar-nav-control'
        @iconLeft='caret-back-outline'
        @subtle={{true}}
        @size='sm'
        {{! @glint-expect-error: onChange accepts any not string}}
        @onClick={{stopPropagation (fn @calendar.actions.moveCenter -1 'month')}}
      />
      <div
        class='ember-power-calendar-nav-title u-d-flex u-align-items-center u-justify-content-center'
      >
        {{#if (has-block)}}
          {{yield @calendar}}
        {{else}}
          {{#let
            (component
              BvSelect
              size='sm'
              hideTriggerCaret=true
              subtle=true
              matchTriggerWidth=false
              renderInPlace=false
              renderAll=true
              preventScroll=true
            )
            as |PeriodSelect|
          }}
            {{#let
              (momentFormat (utc @calendar.center) 'MMMM' locale=@calendar.locale)
              as |currentMonth|
            }}
              <PeriodSelect
                @options={{this.months}}
                @selected={{currentMonth}}
                {{! @glint-expect-error: onChange accepts any not string}}
                @onChange={{fn this.changeCalCenter 'month' @calendar}}
                as |month|
              >
                {{month}}
              </PeriodSelect>
            {{/let}}
            {{#let
              (momentFormat (utc @calendar.center) 'YYYY' locale=@calendar.locale)
              as |currentYear|
            }}
              <PeriodSelect
                @options={{this.years}}
                @selected={{currentYear}}
                @matchTriggerWidth={{true}}
                {{! @glint-expect-error: onChange accepts any not string}}
                @onChange={{fn this.changeCalCenter 'year' @calendar}}
                {{! @glint-expect-error: Subclassing is bad }}
                @fill={{@showNextMonth}}
                as |year|
              >
                {{! @glint-expect-error: Subclassing is bad }}
                <BvText @text={{year}} class={{if @showNextMonth 'u-text-center u-full-width'}} />
              </PeriodSelect>
            {{/let}}
            {{! @glint-expect-error: Subclassing is bad }}
            {{#if @showNextMonth}}
              {{#let
                (momentFormat
                  (momentAdd (utc @calendar.center) 1 precision='months')
                  'MMMM'
                  locale=@calendar.locale
                )
                as |nextMonth|
              }}
                <PeriodSelect
                  @options={{this.months}}
                  @selected={{nextMonth}}
                  {{! @glint-expect-error: onChange accepts any not string}}
                  @onChange={{fn this.changeCalCenter 'month' @calendar}}
                  as |month|
                >
                  {{month}}
                </PeriodSelect>
              {{/let}}
            {{/if}}
          {{/let}}
        {{/if}}
      </div>
      <BvBtn
        class='ember-power-calendar-nav-control'
        @iconLeft='caret-forward-outline'
        @size='sm'
        @subtle={{true}}
        {{! @glint-expect-error: onChange accepts any not string}}
        @onClick={{fn (stopPropagation (fn @calendar.actions.moveCenter 1 'month'))}}
      />
    </nav>
  </template>
  get months() {
    return moment.months();
  }

  get years() {
    const nbYears = 10;
    const years = [];
    for (let i = -nbYears; i < nbYears * 2; i++) {
      years.push(`${i + moment.utc().year()}`);
    }
    return years;
  }

  @action
  changeCalCenter(
    unit: 'year' | 'month',
    calendar: PowerCalendarAPI,
    value: string,
    _select: Select,
    e: MouseEvent
  ) {
    const newCenter = moment.utc(calendar.center).clone()[unit](value) as moment.Moment;
    calendar.actions.changeCenter?.(newCenter.toDate(), calendar, e);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCalendar::Nav': typeof BvCalendarNavComponent;
    'bv-calendar/nav': typeof BvCalendarNavComponent;
  }
}
